<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-data-table
      :headers="headers"
      :items="list"
      class="elevation-1 bookTable"
      hide-default-footer
      disable-pagination
      @click:row="openBook($event)"
    >
      <template v-slot:top>
        <template>
          <v-btn
            class="float-right mt-3 mr-3"
            color="primary"
            dark
            @click="uploadBookData.uploadDialog = true"
            >New Book</v-btn
          >
        </template>
        <v-toolbar flat color="white">
          <v-toolbar-title>Books</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-row class="ml-2 mr-2">
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-text-field
              v-model="filter_name"
              label="Book Name"
              outlined
              dense
              @keyup="searchFilter"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-select
              :items="itemsLangs"
              v-model="filter_lang"
              label="Lang"
              dense
              outlined
              item-text="langname"
              item-value="langid"
              @change="searchFilter"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-select
              :items="itemsStatus"
              v-model="filter_status"
              label="Status"
              dense
              outlined
              item-text="Name"
              @change="searchFilter"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-select
              :items="itemsDownloadable"
              v-model="filter_downloadable"
              label="Downloadable"
              dense
              outlined
              item-text="Name"
              @change="searchFilter"
            ></v-select>
          </v-col>

          <v-col  cols="12" sm="6" md="4" class="pt-0 pb-0">
            <v-autocomplete
              v-model="categoriesObject"
              :items="categoriesObject"
              outlined
              dense
              :readonly="true"
              chips
              class="mx-3"
              small-chips
              label="Categories"
              multiple
              item-text="categoryname"
              item-value="categoryid"
              @focus="dialogCategoryTree = true"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.bookid`]="{ item }">
        {{
          list
            .map(function (x) {
              return x.bookid;
            })
            .indexOf(item.bookid) + 1
        }}
      </template>
      <template v-slot:[`item.counterview`]="{ item }">
        <v-chip class="mr-2 chipsstyle" color="green" label outlined>
          {{ item.counterview }}
        </v-chip>
        Once
      </template>
      <template v-slot:[`item.counterdownload`]="{ item }">
        <v-chip class="mr-2 chipsstyle" color="green" label outlined>
          {{ item.counterdownload }}
        </v-chip>
        Once
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <p v-if="item.status == false">
          <span title="Not Active"
            ><i class="status fa fa-times-circle red--text"></i
          ></span>
        </p>
        <p v-if="item.status == true">
          <span title="Active"
            ><i class="status fa fa-check-circle green--text"></i
          ></span>
        </p>
      </template>
      <template v-slot:[`item.ispublish`]="{ item }">
        <p v-if="item.ispublish == false">
          <span title="Not Publishing"
            ><i class="status fa fa-clock orange--text"></i
          ></span>
        </p>
        <p v-if="item.ispublish == true">
          <span title="Publishing"
            ><i class="status fas fa-check-double blue--text"></i
          ></span>
        </p>
      </template>
      
      <template v-slot:[`item.action`]="{ item }">
        <!-- <v-icon
          title="New Version"
          small
          class="mr-2"
          color="green"
          @click.stop="addVersion(item)"
        >
          mdi-plus-circle
        </v-icon> -->
  
        <router-link class="text-decoration-none"  :to="'/book/details/' + item.bookid"
        ><v-icon
          title="Edit"
          small
          class="mr-2"
          color="#1976D2"
        >
          mdi-pencil
        </v-icon></router-link>
        
        <v-icon
          title="Delete"
          small
          @click.stop="deleteItemMethod(item)"
          color="#FF5252"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <template>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="PagesNumber"
          :total-visible="7"
          @input="changePage($event)"
        ></v-pagination>
      </div>
    </template>
    <AddVersion
      :ItemDetails="ItemDetails"
      :addDialogVersion="addDialogVersion"
      v-on:DialogClose="DialogClose($event)"
    />
    <DeleteBook
      :deleteBook="deleteBook"
      :deleteItem="deleteItem"
      v-on:DialogClose="DialogClose($event)"
    />

    <UploadFile v-model="uploadBookData" />

    <SelectTreeCategory
      :dialogCategoryTree="dialogCategoryTree"
      v-on:closeCatDialog="closeCategory($event)"
      v-on:closeCatDialogWithCategories="
        closeCatDialogWithCategoriesMethod($event)
      "
    />

  </v-container>
</template>

<style>
.chipsstyle {
  min-width: 80px;
  display: inline-block;
  text-align: center;
}
.bookTable tr:hover *{
  background-color: rgb(193, 207, 255) !important;
  cursor: pointer;
}
</style>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import AddVersion from "@/components/Versions/AddVersion";
import DeleteBook from "@/components/Books/DeleteBook";
import SelectTreeCategory from "@/components/Category/SelectTreeCategory";

import UploadFile from "@/components/Books/UploadBookDialog";

export default {
  data: () => ({
    rules: {
        requiredArray: (value) => value != "" || "Field required.",
      },

    uploadBookData :{
      uploadDialog : false ,
      BookInformation : {} ,
    },
    versionsBook: [],
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "Books",
        disabled: true,
      },
    ],
    headers: [
      { text: "#", value: "bookid" , width: "5%" },
      { text: "Book Name", value: "bookname"  , width: "30%" },
      { text: "Counter View", value: "counterview" ,  width: "15%" },
      { text: "Counter Download", value: "counterdownload"  , width: "15%"},
      { text: "Status", value: "status"  , width: "10%" },
      { text: "Published", value: "ispublish"  , width: "10%"},
      { text: "Action ", value: "action"  , width: "15%" },
    ],
    dialogCategoryTree: false,
    categoriesObject: [],
    selectedCatIDS : '' ,

    itemsStatus: [
      { Name: "All", value: "" },
      { Name: "Active", value: 1 },
      { Name: "Not Active", value: 0 },
    ],
    itemsDownloadable: [
      { Name: "All", value: "" },
      { Name: "Downloadable", value: 1 },
      { Name: "Not Downloadable", value: 0 },
    ],
    list: [],
    itemsLangs: [{ langname: "All", langid: "" }],
    page: 1,
    PagesNumber: 0,
    pageUrl: 1,
    filterStatmint : '' ,
    filter_name: "",
    filter_status: "",
    filter_downloadable: "",
    filter_lang: "",
    editItem: {},
    deleteItem: {},

    // ------- add version -------
    ItemDetails: {},
    addDialogVersion: false,
    // ------- Delete Book -------
    deleteBook: false,
    versionsLoading: false,
    selectedVersion : '' ,

    uploadBookDialog : false ,

  }),
  mounted() {
    this.pageUrl = this.$store.getters.getPageIndexBook ;
    this.getAllLang();
    this.filterStatmint =this.$store.getters.getFilterIndexBook 
    this.getAllBooks();
  },
  components: {
    Breadcrumbs,
    AddVersion,
    DeleteBook,
    UploadFile,
    SelectTreeCategory
  },
  methods: {
    openBook(item){ 
      this.$store.commit("setFilterIndexBook" , this.filterStatmint)
      let APIGetVersion = "/admin/book/"+ item.bookid +"/version" ;
      this.$store
        .dispatch("GetFromAPI", APIGetVersion)
        .then((response) => {
         this.$router.push({
        name: "ReadBook",
        params: {bookID:item.bookid , versionID: response.data.data[0]['versionid'] },
      });
        });

    },
    getAllBooks() {
      this.page = this.$store.getters.getPageIndexBook
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/book?per_page=20&page=" + this.pageUrl  + this.filterStatmint
        )
        .then((response) => {
          this.PagesNumber = response["data"]["meta"]["last_page"];
          this.list = response["data"]["data"];
        });
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/admin/lang").then((response) => {
        for (let index = 0; index < response["data"]["data"].length; index++) {
          this.itemsLangs.push({
            langname: response["data"]["data"][index]["langname"],
            langid: response["data"]["data"][index]["langid"],
          });
        }
      });
    },
    changePage(val) {
      this.$store.commit("setPageIndexBook" , val)
      this.pageUrl = this.$store.getters.getPageIndexBook ;
      this.getAllBooks();
    },
    searchFilter() {
      this.pageUrl = 1;
      this.filterStatmint =
        "&filter[bookname]=" +
        this.filter_name +
        "&filter[status]=" +
        this.filter_status +
        "&filter[isdownloadable]=" +
        this.filter_downloadable +
        "&filter[langid]=" +
        this.filter_lang + 
        "&filter[categories.categoryid]=" +
        this.selectedCatIDS;
      this.getAllBooks();
    },
    goAddBook() {
      this.$router.push({ name: "UploadBook" }).catch(() => {});
    },
    editItemMethod(item) {
      this.editItem = { ...item };
      this.editDialog = true;
    },
    deleteItemMethod(item) {
      this.deleteItem = { ...item };
      this.deleteBook = true;
    },
    addVersion(item) {
      this.ItemDetails = item;
      this.addDialogVersion = true;
    },
    DialogClose(val) {
      if (val == true) {
        this.getAllBooks();
      }
      this.addDialogVersion = false;
      this.deleteBook = false;
    },
    bookDitails(item) {
      this.$router.push({
        name: "DetailsBook",
        params: { bookID: item.bookid },
      });
    },
    closeCategory() {
      this.dialogCategoryTree = false;
    },
    closeCatDialogWithCategoriesMethod(vals) {
      this.categoriesObject = vals;
      let categoryID = [];
      for (let index = 0; index < vals.length; index++) {
        categoryID.push(vals[index]["categoryid"]);
      }
      this.dialogCategoryTree = false;
      this.selectedCatIDS = ''
      for (let index = 0; index < categoryID.length; index++) {
        this.selectedCatIDS += categoryID[index] + ','
      }
      this.searchFilter()
    },
  },
};
</script>